import React from "react";
import { useTranslation } from "react-i18next";
import { SocialFacebook } from "../../common/SocialFacebook";
import { Link } from "react-router-dom";

import { StarIcon } from "../../../assets/image/StarIcon";
import { WhiteStarIcon } from "../../../assets/image/WhiteStarIcon";
import { FavoriteProfile } from "../../common/FavoriteProfile";
import { PhoneIcon } from "../../../assets/image/PhoneIcon";
import { ConfirmIcon } from "../../../assets/image/ConfirmIcon";
import { ServiceIcon } from "../../../assets/image/ServiceIcon";
import { SearchIcon } from "../../../assets/image/SearchIcon";
import { MarkRoundIcon } from "../../../assets/image/MarkRoundIcon";

export const InterviewItem = ({
  data,
  index,
  profile,
  providerData,
  hire,
  handleSubmit,
  setView,
  rate,
  handleElementById,
}) => {
  const { t, i18n } = useTranslation();
  const language = i18n.language;

  const parseIfJson = (value) => {
    try {
      return typeof value === "string" ? JSON.parse(value) : value;
    } catch {
      return value;
    }
  };

  const getTranslatedInterest = (data) => {
    const interestedIn = data.tutorintrestedin || data.nanyintrestedin;
    const interest = parseIfJson(interestedIn);

    if (typeof interest === "string") return t(interest);
    if (interest?.occasionally && interest.occasionally !== "") return t(interest.occasionally);
    if (interest?.fulltime && interest.fulltime !== "") return t(interest.fulltime);
    if (interest?.parttime && interest.parttime !== "") return t(interest.parttime);
    return t(interest.occasionally);
  };

  return (
    <>
      <div class="looking_for_candidate_boxs">
        <div class="looking_for_candidate_box">
          <div class="second_sec">
            <div class="heading">
              <h3>
                {data.profile_headline != null ? data.profile_headline : ""}
              </h3>
              {providerData &&
              providerData[0] &&
              providerData[0].status == 1 ? (
                <button
                  style={
                    ((hire && hire !== "") || data.hire_status === 1)
                      ? { opacity: "0.5", width: language === 'sr' ? '71px' : '51px' }
                      : { width: language === 'sr' ? '71px' : '51px' }
                  }
                  onClick={(e) => handleSubmit(data.provider_id)}
                  disabled={((hire && hire !== "") || data.hire_status === 1)}
                >
                  {((hire && hire !== "") || data.hire_status === 1) ? t("text-hired") : t("text-hire")}
                </button>
              ) : (
                ""
              )}
              {data.plateformsocialmedia == "Yes" ? (
                <SocialFacebook
                  link={
                    window.location.origin +
                    "/profile-provider/" +
                    data.provider_id
                  }
                />
              ) : (
                ""
              )}
            </div>
            <div class="post_general">
              <h6>
                <Link to={"/profile-provider/" + providerData[0]?.UID}>
                  {data.first_name != null
                    ? data.first_name + " " + data.last_name + " "
                    : ""}
                </Link>
                (
                {data.dob != undefined
                  ? new Date().getFullYear() -
                    parseInt(
                      data.dob
                        .substr(data.dob.lastIndexOf("\\") + 1)
                        .split("-")[0]
                    )
                  : ""}
                )
              </h6>
              <p>
                {rate.reviewAvg >= 0 ? (
                  <>
                    {[...Array(rate.reviewAvg)].map((star, index) => {
                      index += 1;
                      return <StarIcon />;
                    })}
                    {[...Array(5 - rate.reviewAvg)].map((star, index) => {
                      index += 1;
                      return <WhiteStarIcon />;
                    })}
                  </>
                ) : (
                  ""
                )}
                <span> ({rate.reviewcount})</span>
              </p>
            </div>
            <div class="post_detail">
              <div class="post">
                {JSON.parse(data.service_type) != null &&
                  (Object.values(JSON.parse(data.service_type))[0] ==
                  "Nanny" ? (
                    <img
                      src={window.location.origin + "/images/nany_post.svg"}
                      alt=""
                    />
                  ) : Object.keys(JSON.parse(data.service_type))[0] ==
                    "tab2" ? (
                    <img
                      src={window.location.origin + "/images/teacher_post.svg"}
                      alt=""
                    />
                  ) : Object.keys(JSON.parse(data.service_type))[0] ==
                    "tab3" ? (
                    <img
                      src={
                        window.location.origin + "/images/education_post.svg"
                      }
                      alt=""
                    />
                  ) : Object.keys(JSON.parse(data.service_type))[0] ==
                    "tab4" ? (
                    <img
                      src={window.location.origin + "/images/tutor_post.svg"}
                      alt=""
                    />
                  ) : (
                    ""
                  ))}
                <h5>
                  {JSON.parse(data.service_type) != null
                    ? Object.values(JSON.parse(data.service_type))[0] ==
                      "Special Education Paraprofessional"
                      ? t("sped-paraprofessional")
                      : Object.values(JSON.parse(data.service_type))[0] ==
                        "Special Education Teacher"
                      ? t("sped-teacher")
                      : t(Object.values(JSON.parse(data.service_type))[0])
                    : ""}
                </h5>
              </div>
              <div class="vi"></div>
              <div class="post_pay">
                <img
                  src={window.location.origin + "/img/post_pay.png"}
                  alt=""
                />
                {language == 'sr' ? (
                  <h5>
                    {data.nanyperhrrate != null
                      ? '$ ' + data.nanyperhrrate
                          .substr(data.nanyperhrrate.lastIndexOf("\\") + 1)
                          .split("-")[0] *
                          100 +
                        " - " +
                        data.nanyperhrrate
                          .substr(data.nanyperhrrate.lastIndexOf("\\") + 1)
                          .split("-")[1] *
                          100
                      : data.tutorperhrrate
                      ? data.tutorperhrrate
                          .substr(data.tutorperhrrate.lastIndexOf("\\") + 1)
                          .split("-")[0] *
                          100 +
                        " - " +
                        data.tutorperhrrate
                          .substr(data.tutorperhrrate.lastIndexOf("\\") + 1)
                          .split("-")[1] *
                          100
                      : ""}
                    {t("time-hour")}
                  </h5>
                ) : (
                  <h5>
                    $
                    {data.nanyperhrrate != null
                      ? data.nanyperhrrate
                      : data.tutorperhrrate
                      ? data.tutorperhrrate
                      : ""}
                    {t("time-hour")}
                  </h5>
                )}
              </div>
              <div class="vi"></div>
              {data.service_type != null &&
              Object.values(JSON.parse(data.service_type))[1] ? (
                <>
                  <div class="post">
                    {data.service_type != null ? (
                      Object.values(JSON.parse(data.service_type))[1] ==
                      "Nanny" ? (
                        <img
                          src={window.location.origin + "/images/nany_post.svg"}
                          alt=""
                        />
                      ) : Object.keys(JSON.parse(data.service_type))[1] ==
                        "tab2" ? (
                        <img
                          src={
                            window.location.origin + "/images/teacher_post.svg"
                          }
                          alt=""
                        />
                      ) : Object.keys(JSON.parse(data.service_type))[1] ==
                        "tab3" ? (
                        <img
                          src={
                            window.location.origin +
                            "/images/education_post.svg"
                          }
                          alt=""
                        />
                      ) : Object.keys(JSON.parse(data.service_type))[1] ==
                        "tab4" ? (
                        <img
                          src={
                            window.location.origin + "/images/tutor_post.svg"
                          }
                          alt=""
                        />
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}
                    <h5>
                      {JSON.parse(data.service_type) != null
                        ? Object.values(JSON.parse(data.service_type))[1] ==
                          "Special Education Paraprofessional"
                          ? t("sped-paraprofessional")
                          : Object.values(JSON.parse(data.service_type))[1] ==
                            "Special Education Teacher"
                          ? t("sped-teacher")
                          : Object.values(JSON.parse(data.service_type))[1]
                        : ""}
                    </h5>
                  </div>
                  <div class="vi"></div>

                  <div class="post_pay">
                    <img
                      src={window.location.origin + "/img/post_pay.png"}
                      alt=""
                    />
                    {language == 'sr' ? (
                      <h5>
                        {data.tutorperhrrate
                          ? '$ ' + data.tutorperhrrate
                              .substr(data.tutorperhrrate.lastIndexOf("\\") + 1)
                              .split("-")[0] *
                              100 +
                            " - " +
                            data.tutorperhrrate
                              .substr(data.tutorperhrrate.lastIndexOf("\\") + 1)
                              .split("-")[1] *
                              100
                          : ""}
                        {t("time-hour")}
                      </h5>
                    ) : (
                      <h5>
                        ${data.tutorperhrrate ? data.tutorperhrrate : ""}
                        {t("time-hour")}
                      </h5>
                    )}
                  </div>
                  <div class="vi"></div>
                </>
              ) : (
                ""
              )}
              <div class="vi"></div>
              <div class="post_fet">
                <img
                  src={window.location.origin + "/images/post_fet.svg"}
                  alt=""
                />
                <h5>
                  {getTranslatedInterest(data)}
                </h5>
              </div>
              <div class="vi"></div>
              <div class="post_cal">
                <img
                  src={window.location.origin + "/images/post_cal.svg"}
                  alt=""
                />
                <h5>
                  {data.tutorstartdate != null
                    ? data.tutorstartdate
                    : data.nanystartdate}
                </h5>
              </div>
              <div class="vi"></div>
              <div class="post_loc">
                <img
                  src={window.location.origin + "/images/post_loc.svg"}
                  alt=""
                />
                <h5>
                  {data.country != null ? data.country : ""} ,
                  {data.city != null ? data.city : ""}
                </h5>
              </div>
            </div>
          </div>
          <div class="second_sec" style={{
            maxWidth: "55rem",
          }}>
            <p id={"half" + index}>
              {data.about != null ? data.about.substr(0, 100) : ""}
              {data.about != null && data.about.length > 100 ? (
                <span
                  onClick={(e) =>
                    handleElementById(
                      "half" + index,
                      "full" + index,
                      "plink" + index
                    )
                  }
                >
                  {t("text-more")}
                </span>
              ) : (
                ""
              )}
            </p>
            <p id={"full" + index} className="hide" style={{
              overflowWrap: "break-word",
            }}>
              {data.about}
              <span
                onClick={(e) =>
                  handleElementById(
                    "full" + index,
                    "half" + index,
                    "plink" + index
                  )
                }
              >
                less
              </span>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};
